import { connect } from "react-redux"

import FormActionButtonsWidget from "./FormActionButtonsWidget"

export default function buildEditFormActionButtonsWidgetContainer(
    applyModelUpdateActionCreator,
    cancelModelUpdateActionCreator,
    presentationAccessor
) {
    const mapStateToProps = ({ presentation }, props) => ({
        canSave: presentation[presentationAccessor].canSave,
        canCancel: presentation[presentationAccessor].canCancel,
        isCreateMode: presentation[presentationAccessor].isCreateMode,
        isSaving: presentation[presentationAccessor].isSavingItem,
        updateModel: presentation[presentationAccessor].updateModel,
        // needsConfirmation is specific to insightArea page
        needsConfirmation:
            presentation[presentationAccessor].mediaToDelete &&
            presentation[presentationAccessor].mediaToDelete.length,
        ...props
    })

    const mapDispatchToProps = dispatch => ({
        cancel: () => dispatch(cancelModelUpdateActionCreator()),
        save: () => dispatch(applyModelUpdateActionCreator())
    })

    return connect(mapStateToProps, mapDispatchToProps)(FormActionButtonsWidget)
}
